import { render, staticRenderFns } from "./GonggaoDetails.vue?vue&type=template&id=c1ee5458&"
import script from "./GonggaoDetails.vue?vue&type=script&lang=js&"
export * from "./GonggaoDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports